@if (entity?.logoUrl) {
  <img class="img-fluid" [src]="entity?.logoUrl" [alt]="entity?.name" [title]="entity?.name">
} @else {
  <!-- Setting line-height to 1 ensures that the icon's height is the exact size of the font -->
  <div style="line-height: 1;" [ngStyle]="{'font-size': fontSize}">
    <app-single-letter-icon [text]="entity?.name" noTextPlaceContent="-" [fontSize]="fontSize"/>
  </div>
}
